<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div class="tsv-words">

    <header class="mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600">
      <div class="mdl-layout__header-row">

        <span v-if="analyzer.type == 'words'" class="mdl-layout-title">{{ global_i18n().words.title }}</span>
        <span v-if="analyzer.type == 'ads'" class="mdl-layout-title">{{ global_i18n().ads.title }}</span>

        <div class="mdl-layout-spacer"></div>
        <div class="search" v-if="inputTable">
          <div class="mdl-textfield mdl-js-textfield mdl-textfield--expandable">
            <label class="mdl-button mdl-js-button mdl-button--icon" for="search">
              <i class="material-icons">search</i>
            </label>
            <div class="mdl-textfield__expandable-holder">
              <input class="mdl-textfield__input" type="text" id="search" :value="searchText"
                     @change="handleSearchChange($event, true)"
                     @input="handleSearchChange($event, false)">
              <label class="mdl-textfield__label" for="search">{{ i18n().searchBox }}</label>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="mdl-grid">

      <div class="load-tsv mdl-card mdl-shadow--2dp" v-if="inputTable == null && state == 'ready' ">
        <div class="mdl-card__title mdl-card--expand">
          <h2 class="mdl-card__title-text">{{ i18n().csvOrTsv }}</h2>
        </div>
        <div class="mdl-card__supporting-text">
          <LoadFile @file="file => handleFileLoaded(file)">></LoadFile>
        </div>
      </div>

      <div class="file-error-holder" v-if="inputFileError">
        <div class="file-error mdl-card mdl-shadow--4dp">
          <div class="mdl-card__title">
            <h2 class="mdl-card__title-text">{{ i18n().inputError.title }}</h2>
          </div>
          <div class="mdl-card__supporting-text mdl-card--expand">
            {{ i18n().inputError[inputFileError.type] ? i18n().inputError[inputFileError.type](inputFileError)
                                                      : inputFileError.type }}
          </div>
          <div class="mdl-card__actions mdl-card--border">
            <a class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
               v-on:click="retry">
              OK
            </a>
          </div>
        </div>
      </div>

      <div class="parsing-holder" v-if="state == 'parsing' && !inputFileError">
        <h3>Reading Data...</h3>
        <div id="p2" class="mdl-progress mdl-js-progress mdl-progress__indeterminate"></div>
        <h4>Please wait!</h4>
      </div>

      <div v-if="state == 'parsed'">
        <div v-if="analyzer.type == 'words'">
          <WordsAnalyzer :inputTable="inputTable" :searchText="searchText"
                         @file="file => handleFileLoaded(file)">
          </WordsAnalyzer>
        </div>
        <div v-if="analyzer.type == 'ads'">
          <AdsAnalyzer :inputTable="inputTable" :searchText="searchText"
                         @file="file => handleFileLoaded(file)">
          </AdsAnalyzer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import LoadFile from "./utils/LoadFile"
  import WordsAnalyzer from './WordsAnalyzer'
  import AdsAnalyzer from './AdsAnalyzer'

  import WorkerQueue from "../io/WorkerQueue"
  import expression from "../logic/expression"
  import csvParser from "../logic/csvParser"
  import csvParserWorker from 'worker-loader!../logic/csvParser'
  window.csvWorker = csvParserWorker
  import { generateCSV } from "../io/csv"
  import { saveBlob } from "../io/save"
  import i18n from "i18n"
  import logger from "../logger"

  import config from "../config"

  import api from "../api"

  let inputLanguagesObservable = api.observable(['config', "allInputLanguages"])
  const inputLanguagesPromise = new Promise((resolve, reject) => {
    inputLanguagesObservable.observe({
      set: (value) => {
        console.log("INPUT LANGUAGES LOADED", value)
        resolve(value)
      }
    })
  })

  const inputConfigPromise = inputLanguagesPromise.then(inputLanguages => {
    let inputConfig = config.input
    console.log("INPUT CONFIG", inputConfig)

    for(let typeName in inputConfig) {
      inputConfig[typeName].languages = []
    }
    for(let inputLang of inputLanguages) {
      const inputLangConfig = inputLang.config
      for(let typeName in inputLangConfig) {
        let langType = inputLangConfig[typeName]
        let translation = {}
        for(let transItem of langType.columnTranslation) {
          translation[transItem.from] = transItem.to
        }
        console.log("ST", typeName, inputLang.name, translation)
        let lang = {
          lang: inputLang.name,
          columnTranslation: translation,
          summaryRegex: langType.summaryRegex.map(r=>new RegExp(r,"i"))
        }
        inputConfig[typeName].languages.push(lang)
      }
    }

    console.log("INPUT CONFIG WITH LANGS", inputConfig)

    return inputConfig
  })

  const webWorkerQueue = new WorkerQueue(csvParserWorker)

  export default {
    name: 'csv-analyzer',
    metaInfo() {
      return {
        title: this.i18n().title[this.analyzer.type]
      }
    },
    props: {
      analyzer: {
        type: Object,
        default() {
          return {
            type: "words"
          }
        }
      }
    },
    components: {
      LoadFile,
      WordsAnalyzer,
      AdsAnalyzer
    },
    data () {
      return {
        inputData: null,
        inputTable: null,
        state: "ready",
        webWorkerEnabled: localStorage.noWorker ? false : typeof(Worker) !== "undefined",
        searchText: "",
        searchFieldKeyListener: null,
        inputFileError: null
      }
    },
    watch: {
      inputData(data) {
        this.computeInputTable()
      }
    },
    methods: {
      i18n() { return i18n().csvAnalyzer },
      global_i18n() { return i18n() },
      handleFileLoaded(file) {
        const ext = file.name.split('.').pop()
        if(config.files.acceptedExtensions.indexOf(ext) == -1)
          this.inputFileError = { type: 'extension', ext }
        if(file.type && config.files.acceptedMime.indexOf(file.type) == -1)
          this.inputFileError = { type: 'type', fileType: file.type }
        if(this.inputFileError) {
          console.trace("INPUT FILE ERROR")
          return
        }
        this.inputTable = null
        //console.log("LOADED", file)
        var reader = new FileReader()
        var vm = this
        reader.onload = (e) => {
          var data = e.target.result
          vm.inputData = {
            fileName: file.name,
            text: data,
            format: file.name.split('.').pop()
          }
        }
        reader.readAsText(file)
      },
      doWorkerTask(method, args) {
        logger.startLagDetector('csv-'+method, 1000)
        let promise
        if (this.webWorkerEnabled) {
          promise = webWorkerQueue.doWorkerTask(method, args)
        } else {
          promise = new Promise((resolve, reject) => {
            args = JSON.parse(JSON.stringify(args))
            resolve(csvParser[method](...args))
          })
        }
        return promise.then(result => {
          logger.stopLagDetector('csv-'+method)
          return result
        }).catch(error => {
          logger.stopLagDetector('csv-'+method)
          logger.addTag('csv-error','csv-'+method+"-error")
          throw error
        })
      },
      async computeInputTable() {
        const data = this.inputData
        if(!data) return null

        this.inputTable = null
        this.state = "parsing"

        return this.doWorkerTask("parseData", [data, await inputConfigPromise]).then(
          table => {

            /*if(table.type != 'adPerformance' && this.analyzer.type == 'ads') {
              this.inputFileError = { type: "adsQuery" }
              console.trace("INPUT FILE ERROR")
              return;
            }*/

            this.parsing = false
            if(table.columnNames.length <= 1) {
              alert("Unknown file format")
              return this.inputTable = null
            }
            console.log("PARSED TABLE", table)
            this.state = "parsed"
            this.inputTable = table
          }
        ).catch(error => {
          console.error("INPUT FILE ERROR", error)
          this.inputFileError = { type: "format" }
        })
      },
      handleSearchChange(ev, now) {
        const value = ev.target.value
        if(value == this.searchText) return;
        if(now) {
          this.searchText = value
          return;
        }
        this.lastSearchChange = Date.now()
        setTimeout(() => {
          if(Date.now() > config.view.searchDelay) {
            this.searchText = ev.target.value
          }
        }, config.view.searchDelay + 20)
      },
      retry() {
        this.inputFileError = null
        this.state = "ready"
      }
    },
    updated () {
      componentHandler.upgradeAllRegistered();
    },
    mounted () {
      componentHandler.upgradeAllRegistered();
      this.searchFieldKeyListener = (ev) => {
        var ck = ev.keyCode ? ev.keyCode : ev.which;
        if(((ev.ctrlKey || ev.metaKey) && ck == 70) || ck == 191) {
          ev.preventDefault()
          ev.stopPropagation()
          document.querySelector("input#search").focus()
        }
      }
      window.addEventListener('keydown', this.searchFieldKeyListener)
    },
    beforeDestroy() {
      window.removeEventListener('keydown', this.searchFieldKeyListener)
    }
  }

</script>

<style scoped>

  @media screen and (max-width: 1024px) {
    .mdl-layout__header {
      display: block;
    }
  }

  .load-tsv .load-file {
    text-align: center;
  }
  .load-tsv {
    width: 320px;
    height: 460px;
    margin: auto;
  }
  .load-tsv .mdl-card__title {
    height: 123px;
    color: #fff;
    background:
      url('../../static/images/dog.png') bottom right 15% no-repeat #46B6AC;
  }


  .file-error-holder {
    z-index: 10;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
  }
  .file-error-holder .mdl-card__title {
    color: #fff;
    background: #bd0000;
  }
  .file-error {
    margin-left: auto;
    margin-right: auto;
    margin-top: 20%;
  }
  .file-error-holder a {
    float: right;
    color: #bd0000;
  }

</style>



// WEBPACK FOOTER //
// CsvAnalyzer.vue?ad0470b0